const FLOAT_DIALOG_SELECTOR = '[data-product-media-float-dialog]';
const PRODUCT_INFORMATION_SELECTOR = '[data-testid="product-information"]';
const PRODUCT_MEDIA_SELECTOR = '[data-testid="product-information-media"]';
const PRODUCT_MEDIA_ACTIONS_STACK_SELECTOR = '[data-product-media-actions-stack]';
const observedProductInformation = new WeakSet();

function getElements(root, selector) {
  const elements = [...root.querySelectorAll(selector)];

  if (root instanceof Element && root.matches(selector)) {
    elements.unshift(root);
  }

  return elements;
}

function getProductMediaTarget(productInformation) {
  const mediaCandidates = getElements(productInformation, PRODUCT_MEDIA_SELECTOR);

  // 插件替换图库时可能保留隐藏的旧容器；始终优先挂到实际可见的主图容器。
  return mediaCandidates.find((media) => getComputedStyle(media).display !== 'none') ?? mediaCandidates[0];
}

function getProductMediaActionsStack(productMedia) {
  let stack = productMedia.querySelector(PRODUCT_MEDIA_ACTIONS_STACK_SELECTOR);

  if (!stack) {
    stack = document.createElement('div');
    stack.className = 'product-media-actions-stack';
    stack.setAttribute('data-product-media-actions-stack', '');
    productMedia.appendChild(stack);
  }

  return stack;
}

function mountProductMediaFloat(root = document) {
  const scope = root.querySelectorAll ? root : document;

  scope.querySelectorAll(FLOAT_DIALOG_SELECTOR).forEach((dialog) => {
    const productInformation = dialog.closest(PRODUCT_INFORMATION_SELECTOR);
    const productMedia = productInformation && getProductMediaTarget(productInformation);

    if (!productMedia) return;

    const stack = getProductMediaActionsStack(productMedia);

    if (dialog.parentElement !== stack) {
      stack.appendChild(dialog);
    }

    dialog.removeAttribute('data-product-media-float-pending');
  });
}

function observeProductMedia(root = document) {
  getElements(root, PRODUCT_INFORMATION_SELECTOR).forEach((productInformation) => {
    if (observedProductInformation.has(productInformation)) return;

    observedProductInformation.add(productInformation);

    new MutationObserver((mutations) => {
      const hasNewMedia = mutations.some(({ addedNodes }) =>
        [...addedNodes].some(
          (node) =>
            node instanceof Element &&
            (node.matches(PRODUCT_MEDIA_SELECTOR) ||
              node.querySelector(PRODUCT_MEDIA_SELECTOR))
        )
      );

      if (hasNewMedia) {
        mountProductMediaFloat(productInformation);
      }
    }).observe(productInformation, { childList: true, subtree: true });
  });
}

mountProductMediaFloat();
observeProductMedia();

// Shopify 编辑器局部重载 section 或选中 block 时，需要重新确认挂载位置。
document.addEventListener('shopify:section:load', (event) => {
  mountProductMediaFloat(event.target);
  observeProductMedia(event.target);
});

document.addEventListener('shopify:block:select', () => {
  mountProductMediaFloat();
});
